import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import PackageGrid from '../components/dashboard/PackageGrid';
import NextPackageCard from '../components/dashboard/NextPackageCard';
import ConnectButton from '../components/common/ConnectButton';
import Loader from '../components/common/Loader';

const Packages = () => {
  const { connected } = useWallet();
  const { userId, user, heldBucket, initialLoading, isRegistered, refresh } = useUserData();

  if (!connected) {
    return (
      <div className="main-content">
        <div className="connect-prompt">
          <div className="connect-prompt-icon">🔗</div>
          <h2>Connect Your Wallet</h2>
          <div className="mt-lg"><ConnectButton /></div>
        </div>
      </div>
    );
  }

  if (initialLoading) return <Loader text="Loading Packages" />;
  if (!isRegistered) return <Navigate to="/register" replace />;

  return (
    <div className="main-content">
      <div className="page-header">
        <h1 className="page-title">Packages</h1>
        <p className="page-subtitle">Activate packages to unlock higher earnings</p>
      </div>

      {/* Retopup / Next-package CTA at top */}
      <div className="section-heading">
        <span className="section-heading-bar"></span>
        Topup Your Next Package
      </div>
      <div className="mb-lg">
        <NextPackageCard
          topPackageId={user?.topPackageId}
          heldBucket={heldBucket}
          onActivated={refresh}
        />
      </div>

      {/* All 12 packages grid, colored per tier */}
      <div className="section-heading">
        <span className="section-heading-bar"></span>
        All Packages
      </div>
      <PackageGrid userId={userId} topPackageId={user?.topPackageId || 0} onActivated={refresh} />
    </div>
  );
};

export default Packages;
